/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

type InlineSpinnerProps = {
  size?: number;
  className?: string;
};

/**
 * Micro-loading indicator for inline and load-more contexts.
 * Uses the `--seed-base` design token color so it stays consistent
 * Uses the `--seed-base` design token color for consistency.
 *
 * @param size  Diameter in pixels (default: 20).
 * @param className  Additional Tailwind/class names to apply to the wrapper.
 */
const InlineSpinner: React.FC<InlineSpinnerProps> = ({ size = 20, className }) => (
  <span
    data-testid="inline-spinner"
    className={className}
    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `2px solid var(--seed-base)`,
        borderTopColor: 'transparent',
        animation: 'spin 0.7s linear infinite',
        display: 'inline-block',
        flexShrink: 0,
      }}
    />
  </span>
);

export default InlineSpinner;
